import gql from 'graphql-tag';

import lessonTemplateFragment from '~/shared/graphql-queries/lesson-templates/lesson-template-fragment';

export default gql`
  query findByStudentIdLessonTemplateQuery($studentId: MongoID) {
    findByStudentIdLessonTemplateQuery(studentId: $studentId) {
      ...LessonTemplateFragment
    }
  }
  ${lessonTemplateFragment}
`;
